import i18n from './index'
import chinese from './lang/zh-CN/messages.json'

// Source text is explicit at each call site. Never translate arbitrary API data.
const textKeys = Object.create(null)
Object.keys(chinese).forEach(key => { textKeys[chinese[key]] = `ui.${key}` })

export function translateText (source, parameters) {
  const key = textKeys[source]
  return key ? (parameters ? i18n.t(key, parameters) : i18n.t(key)) : source
}
